import { render, staticRenderFns } from "./ReservationRecordList.vue?vue&type=template&id=9d5a0038&"
import script from "./ReservationRecordList.vue?vue&type=script&lang=js&"
export * from "./ReservationRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports